import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UIOverlayViewStatus } from "common-ts/dist/models/UIOverlayViewStatus";

export enum CreateServiceTicketActiveScreen {
    SignUpStart,
    OrderSelect,
    ProductSelect,
    ServiceInput,
    Confirmation
}

export interface CreateServiceTicketStatusFlow {
    status: UIOverlayViewStatus,
    currentScreen: CreateServiceTicketActiveScreen
}

const initialState: CreateServiceTicketStatusFlow = {
    status: UIOverlayViewStatus.OffAndReady,
    currentScreen: CreateServiceTicketActiveScreen.SignUpStart
}

export const overlayCreateServiceTicketSlice = createSlice({
    name: 'overlayCreateServiceTicket',
    initialState,
    reducers: {
        closeOverlayAndReset: (state) => {
            state.status = UIOverlayViewStatus.OffAndReady;
            state.currentScreen = CreateServiceTicketActiveScreen.SignUpStart;
        },

        openOverlay: (state) => {
            state.status = UIOverlayViewStatus.On;
        },

        updateCurrentScreen: (state, action: PayloadAction<CreateServiceTicketActiveScreen>) => {
            state.currentScreen = action.payload;
        },
    },
    extraReducers(builder) {
    }
})

export const { closeOverlayAndReset, openOverlay, updateCurrentScreen } = overlayCreateServiceTicketSlice.actions

export default overlayCreateServiceTicketSlice.reducer